<template>
  <div>
    <v-row v-if="userRoleId != 11">
      <!-- Создание хранилище -->
      <v-col cols="6">
        <span class="subheading mx-1">{{ stringValues.chooseStorage[currentLanguage.language] }}</span> 
        {{ stringValues.or[currentLanguage.language] }}      
     
         <v-btn
            x-small
            class="mx-1"
            @click="createStorageDialog = true"
          >
            {{ stringValues.createNew[currentLanguage.language] }}
          </v-btn>

          <v-dialog
            v-model="createStorageDialog"
            max-width="500"
            persistent
          >
            <v-card>
              <v-card-title>
                Создание хранилища
              </v-card-title>

              <v-form
                ref="createStorageForm"
                v-model="isCreateStorageValid"
              >
                <v-card-text>
                  <v-text-field
                    v-model="storageName"
                    :rules="storageRules"
                    :counter="10"
                    maxlength="10"
                    label="Имя"
                    required
                  ></v-text-field>

                  <v-select
                    v-if="userRoleId == 10"
                    v-model="accessUser"
                    :items="companyUsers"
                    :label="stringValues.users[currentLanguage.language]"
                    :hint="stringValues.chooseAccessInStorage[currentLanguage.language]"
                    :rules="accessUserRules"
                    persistent-hint
                    return-object
                    item-text="firstName"
                    item-value="accessUserId"
                    :disabled="accessStorages.length == 0 || !enableAccessUsers"
                    outlined
                    dense
                  ></v-select>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    small
                    text
                    @click="closeCreateStorageDialog"
                  >
                    {{ stringValues.cancel[currentLanguage.language] }}
                  </v-btn>

                  <v-btn
                    small
                    text
                    color="primary"
                    @click="CreateStorage"
                  >
                    Создать
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
      </v-col>

      <!-- Доступ к хранилище пользователей-->
      <!-- <v-col cols="5" class="d-flex align-center">
        <v-select
          v-model="accessUsers"
          :items="companyUsers"
          :label="stringValues.users[currentLanguage.language]"
          multiple
          :hint="stringValues.chooseAccessInStorage[currentLanguage.language]"
          persistent-hint
          return-object
          item-text="firstName"
          item-value="accessUserId"
          :disabled="accessStorages.length == 0 || !enableAccessUsers"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col cols="1">
        <v-btn
          small
          fab
          @click="CreateAccessUsers"
          :disabled="accessStorages.length == 0 || !enableAccessUsers"
          class="primary--text"
        >
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>

    <!-- Выбор хранилище -->
    <v-autocomplete
      v-model="selectedStorageId"
      :items="accessStorages"
      class="mt-5"
      item-text="storage.name"
      item-value="storage.id"
      label="Выберите хранилище"
      outlined
      dense
      clearable
      :menu-props="{ offsetY: true }"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>
            {{ item.storage.name }}
          </v-list-item-title>

          <v-list-item-subtitle>
            Создано
            <span v-if="currentUser.id == item.storage.userCreatedId">
              Вами
            </span>
            <span v-else>
              пользователем {{ item.storage.userCreated.firstName }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action
          v-if="currentUser.id == item.storage.userCreatedId"
        >
          <v-btn
            icon
            small
            @click.stop="DeleteStorage(item.storage.id)"
          >
            <v-icon color="error">mdi-close-thick</v-icon>
          </v-btn>
        </v-list-item-action>
      </template>

      <template v-slot:selection="{ item }">
        {{ item.storage.name }}
      </template>
    </v-autocomplete>
    <v-alert 
      closable 
      icon="mdi-exclamation" 
      title="" 
      text="" 
      type="info" 
      v-if="userRoleId != 11"> 
        {{ this.optimizeInfo }}
      <br>
      <code v-if="this.selectedFilials.length >= 1"> {{ this.selectedDistrsInfo }}</code>
    </v-alert>
    <!-- предупреждения последней оптимизации: пропущенный филиал заблокированного заказа -->
    <v-alert
      type="warning"
      dismissible
      :value="optimizeWarnings.length > 0"
      @input="(v) => !v && clearOptimizeWarnings()"
      v-if="userRoleId != 11">
      {{ optimizeWarnings.join(" ") }}
    </v-alert>
    <!-- Товары хранилище -->
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="searchGoods"
          append-icon="mdi-magnify"
          :label="stringValues.search[currentLanguage.language]"
          single-line
          hide-details
          outlined
          dense
        ></v-text-field>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-2 primary--text"
              v-on="on"
              fab
              small
              :disabled="selectedGoods.length < 1"
              @click="Optimized"
              v-if="userRoleId != 11"
            >
              <v-icon>mdi-flare</v-icon>
            </v-btn>
          </template>
          <span>Оптимизированный заказ</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-2 primary--text"
              v-on="on"
              fab
              small
              @click="OptimizedExcel"
              v-if="userRoleId != 11"
            >
              <v-icon>mdi-file-excel</v-icon>
            </v-btn>
          </template>
          <span>Оптимизированный заказ Excel</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-2 primary--text"
              v-on="on"
              fab
              small
              :disabled="selectedGoods.length < 1"
              @click="DeleteStorageGoods()"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Удалить из хранилища</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2 primary--text" v-on="on" fab small @click="filter = !filter">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Выбрать поставщиков</span>
        </v-tooltip>
      </v-card-title>
      <v-row>
        <v-col cols="12" class="px-7 py-4">
          <v-expand-transition>
            <div v-show="filter">
              <v-row>
                <v-col cols="8" sm="6">
                  <v-autocomplete v-model="selectedFilials" :label="selectedDistrsInfo" :items="filialItems" item-text="name"
                    item-value="id" item-disabled="disabled" dense prepend-icon="mdi-truck-delivery" outlined hide-details multiple>
                    <template #selection="{ item, index }">
                      <span v-if="index === 0">{{ stringValues.provider[currentLanguage.language] }}
                      </span>
                    </template>
                    <!-- филиал заблокированного заказа (Эмити, окно 48 ч): тусклый, некликабельный, с подсказкой почему -->
                    <template #item="{ item, on, attrs }">
                      <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active" :disabled="item.disabled"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <v-list-item-subtitle v-if="item.disabled" class="error--text">
                            <v-icon x-small color="error">mdi-lock</v-icon>
                            {{ blockedFilialHint(item) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="ma-2 primary--text" v-on="on" fab small @click="ClearOptimizeFilter()"
                      :disabled="selectedFilials.length < 1">
                      <v-icon>mdi-filter-off-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Очистить выбранных поставщиков</span>
                </v-tooltip>
              </v-row>
            </div>
          </v-expand-transition>
        </v-col>
      </v-row>
      <v-data-table 
        v-model="selectedGoods" 
        :headers="headers[currentLanguage.language]" 
        :items="storageGoods"
        :search="searchGoods" 
        hide-default-footer 
        fixed-header 
        class="elevation-3" 
        @click:row="GetPriceByGoodsId"
        :loading="loadingGoods" 
        dense 
        item-key="goodsId" 
        filterable 
        show-select height="400" 
        :item-class="getRowColor"
        disable-pagination
      ></v-data-table>
      <v-card-actions class="storage-export-bar">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          rounded
          small
          class="ma-2"
          :loading="loadingExcel"
          :disabled="!currentStorage || storageGoods.length == 0"
          @click="DownloadExcel"
        >
          <v-icon left small>mdi-file-excel</v-icon>
          {{ stringValues.unloadStorageExcel[currentLanguage.language] }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="excelDialog" max-width="500px">
      <v-card>
        <v-card-title>Загрузка Excel файла</v-card-title>
        <v-card-text>
          <v-file-input
            label="Выберите Excel файл"
            accept=".xlsx, .xls"
            v-model="selectedFile"
            prepend-icon="mdi-file-excel"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="excelDialog = false">Отмена</v-btn>
          <v-btn color="primary" @click="uploadExcel">Загрузить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    optimizeWarningsTimer: null,
    createStorageMenu: false,
    isCreateStorageValid: false,
    storageName: "",
    storageRules: [
      (v) => !!v || "Имя обязательно",
      (v) => v.length <= 10 || "Имя должно быть не более 10 символов",
    ],
    accessUserRules: [
      v => !!v?.id  || 'Выберите пользователя'
    ],
    createStorageDialog: false,
    companyUsers: [],
    accessUser: null,
    selectedStorageId: null,
    searchGoods: "",
    selectedGoods: [],
    loadingGoods: false,
    loadingExcel: false,
    headers: {
      "RU": [
        {
          text: "",
          value: "data-table-select",
          class: "primary white--text",
          sortable: false,
        },
        {
          text: "Полное название",
          value: "goods.fullName",
          class: "primary white--text",
          sortable: false,
        },
        {
          text: "Количество",
          value: "quantity",
          class: "primary white--text",
          sortable: false,
        },
        {
          text: "Пользователь",
          value: "userCreated.firstName",
          class: "primary white--text",
          sortable: false,
        },
      ],
      "KZ": [
        {
          text: "",
          value: "data-table-select",
          class: "primary white--text",
          sortable: false,
        },
        {
          text: "Толық атауы",
          value: "goods.fullName",
          class: "primary white--text",
          sortable: false,
        },
        {
          text: "Саны",
          value: "quantity",
          class: "primary white--text",
          sortable: false,
        },
        {
          text: "Пайдаланушы",
          value: "userCreated.firstName",
          class: "primary white--text",
          sortable: false,
        },
      ],
    },
    storageUserId: null,
    activeGoodsId: null,
    filter: false,
    filialInPrices: [],
    selectedFilials: [],
    excelDialog: false,
    selectedFile: null
  }),
  methods: {
    closeCreateStorageDialog() {
      this.$refs.createStorageForm.reset();
      this.createStorageDialog = false;
    },
    CreateStorage() {
      if (!this.$refs.createStorageForm.validate()) {
        return;
      }

      let Storage = {
        name: this.storageName,
        userCreatedId: this.currentUser.id,
        orderOwnerUserId: this.accessUser?.id || null
      };

      this.$store
        .dispatch("CREATE_STORAGE", Storage)
        .then(() => {
          this.closeCreateStorageDialog();
        })
        .catch(() => {
          this.closeCreateStorageDialog();
        }); 
    },
    DeleteStorage(id) {
      if (this.userRoleId === 11)
        return

      this.accessUsers = [];
      this.$store
        .dispatch("DELETE_STORAGE", id)
        .then(() => {
          if (this.selectedStorageId === id) {
            this.selectedStorageId = null;
          }
          
          this.GetStorageGoods();
          this.GetAccessUsers();
        })
        .catch(() => {});
    },
    async DeleteStorageGoods() {
      await this.$store.dispatch("DELETE_STORAGE_GOODS", {
        goodsIds: this.selectedGoods.map((x) => x.goodsId),
        storageId: this.currentStorage.id,
      });
      if (this.$store.getters.DELETE_STORAGE_GOODS_STATUS) {
        let Success = {
          text: "Позиции успешно удалены!",
          timeout: 3000,
          color: "success",
          show: true,
        };
        this.$store.commit("SET_SNACKBAR", Success);
        this.GetStorageGoods();
        this.selectedGoods = [];
      } else {
        let Error = {
          text: "Ошибка при удалении позиций!",
          timeout: 3000,
          color: "danger",
          show: true,
        };
        this.$store.commit("SET_SNACKBAR", Error);
      }
    },
    GetCompanyUsers() {
      this.$store
        .dispatch("USERS_INSIDE_COMPANY")
        .then(() => {
          this.companyUsers = this.$store.getters.USERS;
        })
        .catch(() => {});
    },
    GetAccessUsers() {
      this.accessUsers = [];

      if (!this.currentStorage) {
        return;
      }

      this.$store
        .dispatch("ACCESS_USERS_BY_STORAGE_ID", this.currentStorage?.id)
        .then((response) => {
          this.accessUsers = response.map((x) => x.accessUser);
        })
        .catch(() => {});
    },
    GetStorageGoods() {
      this.selectedGoods = [];
      this.activeGoodsId = null;
      this.loadingGoods = true;
      this.$store.commit("SET_STORAGE_GOODS", []);

      if (!this.currentStorage) {
        this.loadingGoods = false;
        return;
      }

      this.$store
        .dispatch("STORAGE_GOODS", this.currentStorage?.id)
        .then(() => {
          this.loadingGoods = false;
        })
        .catch(() => {
          this.loadingGoods = false;
        });
    },
    CreateAccessUsers() {
      let Storage = {
        StorageId: this.currentStorage?.id,
        AccessUsers: this.accessUsers.map((x) => x.id),
      };
      this.$store
        .dispatch("CREATE_ACCESS_USERS_STORAGE", Storage)
        .then(() => {})
        .catch(() => {});
    },
    GetPriceByGoodsId(value) {
      if (this.userRoleId == 11)
        return;
      this.storageUserId = value.userCreatedId;
      this.activeGoodsId = value.goodsId;
      this.$store.commit("SET_LOADING_ORDER_PRICE", true);
      // row.select(true);

      let payload = {
        goodsId: value.goodsId,
        goods: value.goods,
        storageId: this.currentStorage?.id,
      };

      this.$store
        .dispatch("PRICE_BY_GOODS_ID", payload)
        .then(() => {
          this.$store.commit("SET_LOADING_ORDER_PRICE", false);
          this.$store.commit("SET_ORDER_RIGHT_TAB", "Цены");
        })
        .catch(() => {});
    },
    Optimized() {
      // защита от устаревшего выбора: филиал заблокированного заказа в оптимизацию не отправляем
      const filials = this.selectedFilials.filter((id) => !this.blockedFilialIds.includes(id));
      if (filials.length > 0) {
        let OptimizedDistributors = {
          StorageDetails: this.selectedGoods,
          DistrsIdList: filials,
        };
        this.$store
          .dispatch("OPTIMIZED_ORDER_DISTRS", OptimizedDistributors)
          .then(() => {
            this.GetStorageGoods();
            this.GetOrders();
          })
          .catch(() => { });
      }
      else {
        this.$store
          .dispatch("OPTIMIZED_ORDER", this.selectedGoods)
          .then(() => {
            this.GetStorageGoods();
            this.GetOrders();
          })
          .catch(() => {});
      }
    },
    OptimizedExcel() {
      this.excelDialog = true;
    },
    DownloadExcel() {
      if (!this.currentStorage?.id) return;
      this.loadingExcel = true;
      this.$store
        .dispatch("DOWNLOAD_STORAGE_EXCEL", this.currentStorage.id)
        .catch(() => {})
        .finally(() => {
          this.loadingExcel = false;
        });
    },
    uploadExcel(){
      if(!this.selectedFile){
        alert("Выберите файл перед загрузкой");
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedFile);

      this.$store
          .dispatch("OPTIMIZED_ORDER_EXCEL", formData)
          .then(() => {
            this.GetStorageGoods();
            this.GetOrders();
          })
          .catch(() => { })
          .finally(()=> {
            this.selectedFile = null;
            this.excelDialog = false;
          })
    },
    getRowColor(item) {
      if (item.goodsId === this.activeGoodsId) {
        return "active-row-color";
      }

      let currentIndex = this.storageGoods
        .map((x) => x.goodsId)
        .indexOf(item.goodsId);

      if (currentIndex % 2 == 0) {
        return "gray-row-color";
      } else {
        return "white-row-color";
      }
    },
    GetOrders() {
      this.$store.commit("SET_ORDER_NAVIGATION", 0);
      this.$store.commit("SET_ORDER_FROM_API", true);
      if (this.$store.getters.ACTIVE_POINT != null) {
        this.$store
          .dispatch("ORDERS_BY_USER", this.$store.getters.ACTIVE_POINT)
          .then(() => {
            this.$store.commit("SET_ORDER_FROM_API", false);
          })
          .catch(() => {
          });
      } else {
        this.$store
          .dispatch("ORDERS")
          .then(() => {
            this.$store.commit("SET_ORDER_FROM_API", false);
          })
          .catch(() => { });
      }
    },
    GetUserFilials() {
      this.$store
        .dispatch("GET_FILIALS_IN_PRICES")
        .then(() => {
          this.filialInPrices = this.$store.getters.FILIALS_IN_PRICES;
        })
        .catch((error) => {
          window.console.error(error, "FILIALS_BY_CONTEXT");
        });
    },
    ClearOptimizeFilter() {
      this.selectedFilials = []
      this.filter = false;
    },
    blockedFilialHint(filial) {
      const info = this.$store.getters["blockedOrder/blockedOrderByFilial"](filial.id);
      const template = this.stringValues.blockedSupplierHint[this.currentLanguage.language];
      return template.replace("{0}", info ? info.orderId : "");
    },
    clearOptimizeWarnings() {
      clearTimeout(this.optimizeWarningsTimer);
      this.optimizeWarningsTimer = null;
      this.$store.commit("SET_OPTIMIZE_WARNINGS", []);
    }
  },
  computed: {
    stringValues: {
      get() {
        return this.$store.getters.STRING_VALUES;
      },
    },
    currentLanguage: {
      get() {
        return this.$store.getters.CURRENT_LANG;
      }
    },
    accessStorages: {
      get: function () {
        window.console.log('AccessStorages',  this.$store.getters.ACCESS_STORAGES);
        return this.$store.getters.ACCESS_STORAGES;
      },
    },
    currentStorage: {
      get: function () {
        window.console.log('Id', this.selectedStorageId);
        window.console.log('current',  this.accessStorages.find(
          x => x.storage.id === this.selectedStorageId
        )?.storage)
        return this.accessStorages.find(
          x => x.storage.id === this.selectedStorageId
        )?.storage;
      },
    },
    currentUser: {
      get: function () {
        return this.$store.getters.USER;
      },
    },
    storageGoods: {
      get: function () {
        window.console.log(this.currentStorage?.id)
        window.console.log('storageGoods', this.$store.getters.STORAGE_GOODS);
        return this.$store.getters.STORAGE_GOODS.filter(
          (x) => x.storageId == this.currentStorage?.id
        );
      },
    },
    enableAccessUsers: {
      get: function () {
        return this.currentUser.id === this.currentStorage?.userCreatedId;
      },
    },
    userRoleId: {
      get: function () {
        return this.$store.getters.USER.userRoleId;
      },
    },
    selectedDistrsInfo: {
      get: function () {
        if (this.selectedFilials.length > 0) {
          return this.stringValues.selectedSuppliersCount[this.currentLanguage.language]
            + this.selectedFilials.length;
        }
        return this.stringValues.chooseSupplier[this.currentLanguage.language];
      }
    },
    optimizeInfo: {
      get: function () {
        if (this.selectedFilials.length > 0) {
          return this.stringValues.optimizeOrderInfoDistrs[this.currentLanguage.language];
        }
        return this.stringValues.optimizeOrderByLines[this.currentLanguage.language];
      }
    },
    blockedFilialIds() {
      return this.$store.getters["blockedOrder/blockedFilialIds"];
    },
    // филиал, по которому есть заблокированный заказ, в списке поставщиков тусклый и некликабельный
    filialItems() {
      return this.filialInPrices.map((filial) => ({
        ...filial,
        disabled: this.blockedFilialIds.includes(filial.id),
      }));
    },
    optimizeWarnings() {
      return this.$store.getters.OPTIMIZE_WARNINGS;
    }
  },
  watch: {
    optimizeWarnings(warnings) {
      // предупреждение оптимизатора живёт 10 секунд, крестиком можно закрыть раньше
      clearTimeout(this.optimizeWarningsTimer);
      this.optimizeWarningsTimer = null;
      if (warnings.length > 0) {
        this.optimizeWarningsTimer = setTimeout(this.clearOptimizeWarnings, 10000);
      }
    },
    blockedFilialIds(ids) {
      // блокировка могла появиться уже после выбора поставщиков — снимаем такой филиал с выбора
      this.selectedFilials = this.selectedFilials.filter((id) => !ids.includes(id));
    },
    accessStorages: {
      immediate: true,
      handler(storages) {
        if (!storages || storages.length === 0) {
          this.selectedStorageId = null;
          return;
        }

        const selectedStorageExists = storages.some(
          x => x.storage.id === this.selectedStorageId
        );

        if (!selectedStorageExists) {
          this.selectedStorageId = storages[0].storage.id;
        }
      }
    },
    selectedStorageId() {
      this.GetStorageGoods();
      this.GetAccessUsers();
    }
  },
  mounted() {
    this.GetCompanyUsers();
    this.GetStorageGoods();
    this.GetAccessUsers();
  },
  created() {
    this.GetUserFilials();
    // список блокировок грузит потребность при входе; сюда — только если вкладка открыта раньше него
    if (!this.$store.getters["blockedOrder/myBlockedOrdersLoaded"]) {
      this.$store.dispatch("blockedOrder/fetchMyBlockedOrders");
    }
  },
  beforeDestroy() {
    clearTimeout(this.optimizeWarningsTimer);
  }
};
</script>
<style lang="css">
.white-row-color {
  background-color: #ffffff;
}
.gray-row-color {
  background-color: rgba(0, 0, 0, 0.05);
}
.active-row-color {
  background-color: #b0bec5;
}
.storage-type-card {
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 130px;
}

.storage-type-card:hover {
  transform: translateY(-2px);
}
/* кнопка выгрузки прилипает к низу бокса хранилища */
.storage-export-bar {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: #ffffff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 4px 8px;
}
</style>